(function () {
  var D = window.HKD, root = document.getElementById('hk');
  if (!D || !root) return;
  function $(i) { return document.getElementById(i); }

  /* ---------- LED hand signs ---------- */
  // finger tops left->right: pinky, ring, middle, index (128 = folded)
  var G = {
    mid:   [[128, 128, 22, 128], 0],
    wave:  [[74, 44, 24, 40], 1],
    shaka: [[74, 128, 128, 128], 1],
    point: [[128, 128, 128, 40], 0],
    rock:  [[74, 128, 128, 40], 0]
  };
  var ORDER = ['mid', 'wave', 'shaka', 'point', 'rock'];
  function handPath(t, thumbOut) {
    var X = [50, 88, 126, 164], W = 34, r = 17, v = 158, d = 'M50,232 L50,' + (t[0] + r);
    for (var i = 0; i < 4; i++) {
      var x = X[i];
      if (i > 0) d += ' L' + x + ',' + (t[i] + r);
      d += ' A' + r + ' ' + r + ' 0 0 1 ' + (x + W) + ',' + (t[i] + r);
      if (i < 3) d += ' L' + (x + W) + ',' + v + ' L' + X[i + 1] + ',' + v;
    }
    d += thumbOut
      ? ' L198,176 L230,148 A14 14 0 0 1 248,168 L206,226 Q198,264 162,264 L84,264 Q50,264 50,232 Z'
      : ' L198,196 Q204,236 186,252 Q172,264 150,264 L84,264 Q50,264 50,232 Z';
    return d;
  }
  function draw(el, g) {
    var s = G[g] || G.mid, p = handPath(s[0], s[1]);
    if (!el.firstChild) {
      el.innerHTML = '<svg viewBox="20 0 260 290" aria-hidden="true"><path class="tube"/><path class="dots"/></svg>';
    }
    el.querySelectorAll('path').forEach(function (x) { x.setAttribute('d', p); });
    el.dataset.g = g;
    el.classList.remove('flick'); void el.offsetWidth; el.classList.add('flick');
  }
  root.querySelectorAll('.hk-sign').forEach(function (el) { draw(el, el.dataset.g || 'mid'); });

  // hero fallback sign (no photos yet): cycle on its own
  var heroSign = root.querySelector('.hk-scene--hero .hk-sign');
  if (heroSign) {
    var hi = 0;
    setInterval(function () { hi = (hi + 1) % ORDER.length; draw(heroSign, ORDER[hi]); }, 1800);
  }

  /* ---------- remote demo ---------- */
  var sign = $('hkDemoSign'), remote = $('hkRemote'), hint = $('hkHint'), on = true, cyc = null, ci = 0;
  function mark(btn) { remote.querySelectorAll('.rg button').forEach(function (b) { b.toggleAttribute('data-on', b === btn); }); }
  function stopCycle() { if (cyc) { clearInterval(cyc); cyc = null; } }
  if (remote && sign) {
    remote.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.a === 'power') {
        on = !on; stopCycle(); mark(null);
        sign.toggleAttribute('data-on', on); b.toggleAttribute('data-off', !on);
        hint.textContent = on ? '💡 Back on. Try a gesture.' : '🌙 Off. Press ⏻ to light it up.';
        if (on) draw(sign, sign.dataset.g);
        return;
      }
      if (!on) { hint.textContent = 'Press the red ⏻ button first 👆'; return; }
      if (b.dataset.a === 'cycle') {
        if (cyc) { stopCycle(); mark(null); hint.textContent = 'Cycle stopped.'; return; }
        mark(b); hint.textContent = '🔁 Cycling every gesture… tap 🔁 again to stop';
        ci = ORDER.indexOf(sign.dataset.g);
        cyc = setInterval(function () { ci = (ci + 1) % ORDER.length; draw(sign, ORDER[ci]); }, 1100);
        return;
      }
      stopCycle(); mark(b); draw(sign, b.dataset.g);
      hint.textContent = { shaka: '🤙 Hang loose.', wave: '🖐️ Friendly wave.', point: '☝️ Number one.', rock: '🤘 Rock on.' }[b.dataset.g] || '';
    });
  }

  /* ---------- gallery ---------- */
  root.querySelectorAll('.hk-th').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('.hk-th').forEach(function (x) { x.toggleAttribute('data-on', x === t); });
      var im = $('hkMainImg'); if (im) im.src = t.dataset.src;
    });
  });

  /* ---------- money ---------- */
  function fm(c) {
    var f = D.fmt || '${{amount}}', m = f.match(/\{\{\s*(\w+)\s*\}\}/), n = (c / 100).toFixed(2), nd = Math.round(c / 100) + '';
    var k = m ? m[1] : 'amount', val;
    if (k === 'amount_no_decimals') val = nd.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    else if (k === 'amount_with_comma_separator') val = n.replace('.', ',');
    else if (k === 'amount_no_decimals_with_comma_separator') val = nd.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else val = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return m ? f.replace(m[0], val) : n;
  }

  /* ---------- buy box ---------- */
  var V = D.v, q = +D.q || 1, FS = D.fs || { id: 0, p: 0 };
  var prot = !!($('hkProt') && $('hkProt').checked), fast = !!($('hkFast') && $('hkFast').checked);
  function line(n) { return Math.round(V.p * n * (1 - (D.d[n] || 0))); }
  function full(n) { return Math.max(V.c, V.p) * n; }
  function extras() { return (prot && D.sp.id ? D.sp.p : 0) + (fast && FS.id ? FS.p : 0); }
  function render() {
    root.querySelectorAll('.hk-tier').forEach(function (t) {
      var n = +t.dataset.q, sel = n === q;
      t.toggleAttribute('data-on', sel); t.setAttribute('aria-checked', sel ? 'true' : 'false');
    });
    root.querySelectorAll('[data-tp]').forEach(function (t) {
      var n = +t.dataset.tp, h = fm(line(n));
      if (full(n) > line(n)) h += '<s>' + fm(full(n)) + '</s>';
      if (n > 1) h += '<small>' + fm(Math.round(line(n) / n)) + ' each</small>';
      t.innerHTML = h;
    });
    var tot = line(q) + extras(), was = full(q) + extras();
    if ($('hkProtP')) $('hkProtP').textContent = '+' + fm(D.sp.p);
    if ($('hkFastP')) $('hkFastP').textContent = '+' + fm(FS.p);
    $('hkT').textContent = fm(tot);
    $('hkYS').textContent = was > tot ? '🎉 You save ' + fm(was - tot) + ' today' : '';
    $('hkP').textContent = fm(V.p);
    $('hkC').textContent = V.c > V.p ? fm(V.c) : '';
    var pc = V.c > V.p ? Math.round((1 - V.p / V.c) * 100) : 0;
    $('hkO').textContent = pc ? '-' + pc + '%' : ''; $('hkO').style.display = pc ? '' : 'none';
    $('hkSP').textContent = fm(tot);
    $('hkSQ').textContent = q + (q > 1 ? ' signs · ' + Math.round(D.d[q] * 100) + '% off' : ' sign');
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('.hk-tier'); if (!t) return;
    q = +t.dataset.q; render();
  });
  var pb = $('hkProt');
  if (pb) pb.addEventListener('change', function () { prot = pb.checked; render(); });
  var fb = $('hkFast');
  if (fb) fb.addEventListener('change', function () { fast = fb.checked; render(); });

  function buy(btn) {
    var err = $('hkErr'), R = (D.root || '/').replace(/\/?$/, '/'), old = btn.innerHTML;
    err.textContent = '';
    if (!V.id) { err.textContent = 'Pick the HonkOff product in the theme editor first.'; return; }
    if (!V.a) { err.textContent = 'Sorry, sold out right now.'; return; }
    var up = {}; up[V.id] = 0; if (D.sp.id) up[D.sp.id] = 0; if (FS.id) up[FS.id] = 0;
    var items = [{ id: V.id, quantity: q }];
    if (prot && D.sp.id) items.push({ id: D.sp.id, quantity: 1 });
    if (fast && FS.id) items.push({ id: FS.id, quantity: 1 });
    btn.disabled = true; btn.textContent = 'Loading checkout…';
    var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(R + 'cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: up }) })
      .then(function () { return fetch(R + 'cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); location.href = R + 'checkout'; })
      .catch(function (j) { btn.disabled = false; btn.innerHTML = old; err.textContent = (j && j.description) || 'Something went wrong, please try again.'; });
  }
  $('hkBuy').addEventListener('click', function () { buy(this); });
  $('hkSBuy').addEventListener('click', function () { buy(this); });

  var bb = $('hkBuy'), st = $('hkSticky');
  function stk() { var r = bb.getBoundingClientRect(); st.classList.toggle('on', r.bottom < 0 || r.top > window.innerHeight); }
  window.addEventListener('scroll', stk, { passive: true }); window.addEventListener('resize', stk);
  render(); stk();
})();
